/**
 * CopyrightVersion component module.
 * @module shared/components/CopyrightVersion
 *
 */
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {DescriptiveText} from '../../index';
import moment from 'moment';

const CopyrightVersion = props => {
  const {alignment, product} = props;
  const {version} = product;

  return <div>
    <DescriptiveText alignment={alignment} preset={'paragraph'} margin={props.versionTextMargin}>Version: {version}</DescriptiveText>
    <DescriptiveText alignment={alignment} preset={'paragraph'}>
      &copy;2014-{moment().format('yyyy')} CircleBlack, Inc. All rights reserved.
    </DescriptiveText>
  </div>;
};

const mapStateToProps = state => ({
  product: state.product,
});

export default connect(mapStateToProps, null)(CopyrightVersion);

CopyrightVersion.propTypes = {
  /**
   * The margin of version text.
   */
  versionTextMargin: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right', 'center']),
  product: PropTypes.shape({
    version: PropTypes.string,
  }).isRequired,
};
